import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { Vector3 } from 'three';
import { useThree } from '@react-three/fiber';
import { calculateAngleInfoFromSourceToTarget } from '../../../utils/math';

export interface TableCameraContextValue {
  moveCameraToSeat: (seatPosition: Vector3, tablePosition: Vector3) => void;
}
const TableCameraContext = createContext<TableCameraContextValue | undefined>(undefined);

export const TableCameraProvider = ({ children }: any) => {
  const { camera } = useThree();

  const moveCameraToSeat = useCallback((seatPosition: Vector3, tablePosition: Vector3) => {
    const cameraPosition = camera.position.clone();
    cameraPosition.y = 0;
    const centerOfTable = tablePosition.clone();
    centerOfTable.y = cameraPosition.y;

    const deltaVector = seatPosition.add(tablePosition).sub(camera.position);
    deltaVector.y = 0;
    camera.position.add(deltaVector);
    const angleBetweenCameraAndTableCenter = calculateAngleInfoFromSourceToTarget(camera.position, camera.rotation, centerOfTable);
    camera.rotateOnAxis(new Vector3(0,1,0), angleBetweenCameraAndTableCenter.clockwiseAngleRadians);
  }, [camera]);

  const contextValue = useMemo(() => ({ moveCameraToSeat }), [moveCameraToSeat]);

  return (
    <TableCameraContext.Provider value={ contextValue }>
      {children}
    </TableCameraContext.Provider>
  );
};

export const useTableCamera = () => {
  return useContext(TableCameraContext);
};
